import React, { createContext, useState, useEffect } from 'react'
import { getAttemptCheck } from '../../api/attemptCheckAPI'

const accountLockedAttempts = 3

export const CountdownContext = createContext({
  lockTime: -1,
  checkAttemptLockTime: customCheckMethod => {},
  attempts: 0,
})

const CountdownProvider = ({ children }) => {
  const [lockTime, setLockTime] = useState(-1)
  const [attempts, setAttempts] = useState(0)

  const countdown = () => {
    if (lockTime >= -1) {
      return setTimeout(() => {
        setLockTime(lockTime => lockTime - 1)
      }, 1000)
    }
  }

  const checkAttemptLockTime = customCheckMethod => {
    const getAttemptCheckCall = customCheckMethod || getAttemptCheck
    getAttemptCheckCall().then(data => {
      const { remaining_time: remaining, attempts } = data
      if (remaining > 0) {
        setLockTime(remaining)
      }
      setAttempts(attempts)
    })
  }

  const isAccountLocked = attempts >= accountLockedAttempts

  useEffect(() => {
    const pid = countdown()
    return () => clearTimeout(pid)
  }, [lockTime])

  return (
    <CountdownContext.Provider value={{ lockTime, isAccountLocked, checkAttemptLockTime }}>
      {children}
    </CountdownContext.Provider>
  )
}

export default CountdownProvider
